// extracted by mini-css-extract-plugin
module.exports = {"shell":"App_shell__32fbI"};